import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/assets/css/style.css";
import "../src/assets/css/default.css";
import "../src/assets/css/custom.css";
// import "../src/assets/js/custom"
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
// React Redux In Set Provider
import { Provider } from "react-redux";
import store from "./Component/store/Provider";

// Connect Axios
import { baseURL, secretKey } from "./util/config";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import Loader from "./util/Loader";
import {
  CLOSE_LOADER,
  LOADER_OPEN,
} from "./Component/store/dialogue/dialogue.type";
import { validateSessionIntegrity } from "./util/permissionIntegrity";
import { setToast } from "./util/toast";

// Default Base URL Join In Axios
axios.defaults.baseURL = baseURL;

// Default Key Join In Axios
axios.defaults.headers.common["key"] = secretKey;

const token = sessionStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = token;
}

axios.interceptors.request.use(
  async (req) => {
    if (req.url && !req.url.includes("admin/login")) {
      const isValid = await validateSessionIntegrity();
      if (!isValid) {
        return Promise.reject(new Error("Session tampered"));
      }
    }
    store.dispatch({ type: LOADER_OPEN });
    return req;
  },
  (error) => {
    console.log(error);
  }
);

axios.interceptors.response.use(
  (res) => {
    store.dispatch({ type: CLOSE_LOADER });
    return res;
  },
  (err) => {
    store.dispatch({ type: CLOSE_LOADER });
    const errorMessage = err.response?.data?.message || err.message || "Something went wrong!";
    setToast("error", errorMessage);
    return Promise.reject(err);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
        <ToastContainer />
        <Loader />
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
